export const resources = {
  icons: {
    INSTITUTIONS:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627957/Interswitch/ITG/icons/institution_xp1fmn.svg",
    CONFIGURATION:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627954/Interswitch/ITG/icons/configuration_fstjff.svg",
    CHECK_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/icons/check-solid_la0fnt.svg",
    TIMES_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627961/Interswitch/ITG/icons/times-solid_fyqthh.svg",
    INFO_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627957/Interswitch/ITG/icons/info-solid_a5vykf.svg",
    EYE_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627958/Interswitch/ITG/icons/eye-solid_tn90np.svg",
    EYE_SLASH_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627955/Interswitch/ITG/icons/eye-slash-solid_viv20t.svg",
    CLIPBOARD_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/icons/clipboard-solid_m05gc4.svg",
    CREDIT_CARD:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627955/Interswitch/ITG/icons/credit-card_oyuulr.svg",
    CERTIFICATE_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/icons/certificate-solid_fpfn4b.svg",
    INFO_CIRCLE_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627947896/Interswitch/ITG/icons/info-circle-solid_v3890g.svg",
    ARROW_LEFT_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627947896/Interswitch/ITG/icons/arrow-left-solid_wlil7o.svg",
    ISSUER_PROFILE:
      "https://res.cloudinary.com/jaycodist/image/upload/v1628244678/Interswitch/ITG/icons/issuer-single_hcjnmf.svg",
    COLOR_CANCEL:
      "https://res.cloudinary.com/jaycodist/image/upload/v1628587871/Interswitch/ITG/icons/color-cancel_dkw1ft.svg",
    CLEAR:
      "https://res.cloudinary.com/jaycodist/image/upload/v1629363260/Interswitch/ITG/icons/delete-icon-gray_de9imh.svg",
    SEARCH:
      "https://res.cloudinary.com/jaycodist/image/upload/v1629363260/Interswitch/ITG/icons/search-icon_ahk5po.svg",
    CLOUD_UPLOAD:
      "https://res.cloudinary.com/jaycodist/image/upload/v1641478848/Interswitch/ABU/cloud-arrow-up-solid_bribcm.svg",
    HISTORY:
      "https://res.cloudinary.com/jaycodist/image/upload/v1641478848/Interswitch/ABU/clock-rotate-left-solid_x93srb.svg",
    PORTS:
      "https://res.cloudinary.com/jaycodist/image/upload/v1645178829/Interswitch/Fintech/connection-icon_hztszw.svg",
    CHECK_CIRCLE:
      "https://res.cloudinary.com/jaycodist/image/upload/v1660053505/Interswitch/Fintech/check-circle_dgfiqh.svg",
    TIMES_CIRCLE:
      "https://res.cloudinary.com/jaycodist/image/upload/v1660053505/Interswitch/Fintech/times-circle_fse5wx.svg",
    CALENDAR:
      "https://res.cloudinary.com/jaycodist/image/upload/v1661144623/Interswitch/Fintech/calendar-icon_hirbkp.svg",
    LOADING_DOTS:
      "https://res.cloudinary.com/jaycodist/image/upload/v1667348328/Interswitch/Fintech/loading-icon-dots_utaonm.svg",
    TESTING:
      "https://res.cloudinary.com/jaycodist/image/upload/v1683012287/Interswitch/Fintech/microscope-solid_izka3j.svg",
    REPORT:
      "https://res.cloudinary.com/dtqejx2tl/image/upload/v1697632374/report_owlhze.svg",
    TASK_HISTORY:
      "https://res.cloudinary.com/dtqejx2tl/image/upload/v1697632346/history_qetvyj.svg"
  },
  images: {
    LOADING_WHITE:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/images/loading-icon-white_dwz8su.svg",
    LOADING_BLUE:
      "https://res.cloudinary.com/jaycodist/image/upload/v1646767222/Interswitch/Fintech/loading-icon-blue_aeemq7.svg",
    ANIMATION_IMG:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/images/animation-img_eesphu.svg",
    ANIMATION_IMG_SPIN:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/images/animation-img-spin_iyx9si.svg",
    LOADING_ROSARY:
      "https://res.cloudinary.com/jaycodist/image/upload/v1660034372/Interswitch/Fintech/loading-icon-rosary_ig3d3b.svg",
    LOADING_TAIL:
      "https://res.cloudinary.com/jaycodist/image/upload/v1660034398/Interswitch/Fintech/loading-icon-tail_es02x9.svg",
    LOADING_TYPING:
      "https://res.cloudinary.com/jaycodist/image/upload/v1660034393/Interswitch/Fintech/loading-icon-typing_ueuz4l.svg"
  }
};

const cache = [];

const preloadImages = (images: string[]) => {
  images.forEach(image => {
    const img = new Image();
    img.src = image;
    cache.push(img);
  });
};

preloadImages(Object.values(resources.icons));
preloadImages(Object.values(resources.images));
